// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Dialog Paper ── */
.hold-dialog-paper {
  border-radius: 12px !important;
  padding: 0 !important;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Header ── */
.hold-dialog-header {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.hold-dialog-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.hold-dialog-subtitle {
  font-size: 0.8rem;
  color: #6b7280;
  margin: 2px 0 0;
}

.hold-dialog-close {
  position: absolute;
  top: 14px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 6px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  transition: background 0.15s;
}

.hold-dialog-close:hover {
  background: #f3f4f6;
  color: #111827;
}

/* ── Toolbar (tabs + search) ── */
.hold-dialog-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.hold-tabs {
  display: flex;
  gap: 6px;
}

.hold-tab-btn {
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 5px 16px;
  font-size: 0.82rem;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.hold-tab-btn.active {
  background: #fff;
  border-color: #2563eb;
  color: #2563eb;
  font-weight: 500;
}

.hold-tab-btn:hover:not(.active) {
  background: #f9fafb;
}

.hold-search-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f3f4f6;
  border-radius: 20px;
  padding: 6px 14px;
  flex: 1;
  min-width: 180px;
}

.hold-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.82rem;
  color: #374151;
  width: 100%;
}

.hold-search-input::placeholder {
  color: #9ca3af;
}

/* ── Card Grid ── */
.hold-dialog-body {
  overflow-y: auto;
  flex: 1;
  padding: 16px 20px;
}

.hold-cards-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

/* ── Hold Card ── */
.hold-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fff;
}

.hold-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.hold-card-customer {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hold-card-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #6b7280;
}

.hold-card-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.hold-card-phone {
  font-size: 0.78rem;
  color: #6b7280;
  margin: 2px 0 0;
}

.hold-card-badge {
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.hold-badge-dine-in   { background: #fef3c7; color: #92400e; }
.hold-badge-delivery  { background: #fef3c7; color: #92400e; }
.hold-badge-takeaway  { background: #dbeafe; color: #1e40af; }

/* ── Meta row (time + items) ── */
.hold-card-meta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.hold-card-meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.78rem;
  color: #6b7280;
}

/* ── Product names ── */
.hold-card-products {
  font-size: 0.82rem;
  color: #374151;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Total row ── */
.hold-card-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  border-top: 1px solid #f3f4f6;
}

.hold-card-total-label {
  font-size: 0.85rem;
  color: #374151;
}

.hold-card-total-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111827;
}

/* ── Actions ── */
.hold-card-actions {
  display: flex;
  gap: 10px;
}

.hold-btn-discard {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #ef4444;
  background: none;
  color: #ef4444;
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.hold-btn-discard:hover {
  background: #fef2f2;
}

.hold-btn-retrieve {
  flex: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #2563eb;
  color: #fff;
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}

.hold-btn-retrieve:hover {
  background: #1d4ed8;
}

/* ── Empty / Loader ── */
.hold-empty {
  text-align: center;
  padding: 48px 20px;
  color: #9ca3af;
  font-size: 0.9rem;
  grid-column: 1 / -1;
}

.hold-loader-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  grid-column: 1 / -1;
}

/* Mobile single column */
@media (max-width: 640px) {
  .hold-cards-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Legacy styles (kept for non-dialog mobile view) ── */
.holdOrderContainer {
  background-color: #2B2F42 !important;
  min-width: 100vw !important;
  min-height: 100vh !important;
  margin-top: 3.2rem !important;
}

.hold-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}

.highlighted-row {
  background-color: rgb(159, 177, 213) !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/HoldOrderPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["/* ── Dialog Paper ── */\n.hold-dialog-paper {\n  border-radius: 12px !important;\n  padding: 0 !important;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Header ── */\n.hold-dialog-header {\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.hold-dialog-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n}\n\n.hold-dialog-subtitle {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n.hold-dialog-close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  border-radius: 50%;\n  transition: background 0.15s;\n}\n\n.hold-dialog-close:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n/* ── Toolbar (tabs + search) ── */\n.hold-dialog-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.hold-tabs {\n  display: flex;\n  gap: 6px;\n}\n\n.hold-tab-btn {\n  background: none;\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  padding: 5px 16px;\n  font-size: 0.82rem;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.hold-tab-btn.active {\n  background: #fff;\n  border-color: #2563eb;\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.hold-tab-btn:hover:not(.active) {\n  background: #f9fafb;\n}\n\n.hold-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f3f4f6;\n  border-radius: 20px;\n  padding: 6px 14px;\n  flex: 1;\n  min-width: 180px;\n}\n\n.hold-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 0.82rem;\n  color: #374151;\n  width: 100%;\n}\n\n.hold-search-input::placeholder {\n  color: #9ca3af;\n}\n\n/* ── Card Grid ── */\n.hold-dialog-body {\n  overflow-y: auto;\n  flex: 1;\n  padding: 16px 20px;\n}\n\n.hold-cards-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n/* ── Hold Card ── */\n.hold-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: #fff;\n}\n\n.hold-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.hold-card-customer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.hold-card-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #6b7280;\n}\n\n.hold-card-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n\n.hold-card-phone {\n  font-size: 0.78rem;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n.hold-card-badge {\n  border-radius: 20px;\n  padding: 3px 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.hold-badge-dine-in   { background: #fef3c7; color: #92400e; }\n.hold-badge-delivery  { background: #fef3c7; color: #92400e; }\n.hold-badge-takeaway  { background: #dbeafe; color: #1e40af; }\n\n/* ── Meta row (time + items) ── */\n.hold-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.hold-card-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.78rem;\n  color: #6b7280;\n}\n\n/* ── Product names ── */\n.hold-card-products {\n  font-size: 0.82rem;\n  color: #374151;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Total row ── */\n.hold-card-total {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 8px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.hold-card-total-label {\n  font-size: 0.85rem;\n  color: #374151;\n}\n\n.hold-card-total-value {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n/* ── Actions ── */\n.hold-card-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.hold-btn-discard {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid #ef4444;\n  background: none;\n  color: #ef4444;\n  border-radius: 6px;\n  padding: 7px 12px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.hold-btn-discard:hover {\n  background: #fef2f2;\n}\n\n.hold-btn-retrieve {\n  flex: 1.4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  border-radius: 6px;\n  padding: 7px 12px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.hold-btn-retrieve:hover {\n  background: #1d4ed8;\n}\n\n/* ── Empty / Loader ── */\n.hold-empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: #9ca3af;\n  font-size: 0.9rem;\n  grid-column: 1 / -1;\n}\n\n.hold-loader-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 20px;\n  grid-column: 1 / -1;\n}\n\n/* Mobile single column */\n@media (max-width: 640px) {\n  .hold-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Legacy styles (kept for non-dialog mobile view) ── */\n.holdOrderContainer {\n  background-color: #2B2F42 !important;\n  min-width: 100vw !important;\n  min-height: 100vh !important;\n  margin-top: 3.2rem !important;\n}\n\n.hold-loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n}\n\n.highlighted-row {\n  background-color: rgb(159, 177, 213) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
